import { del, get, post, postForm, put, putForm, apiWrapper } from "../Utilities/Requests";
import * as url from "../Utilities/Request-Endpoints"

const formDataConfiguration = { headers: { 'content-type': 'multipart/form-data' } };
// export const updatePassword = (data) => apiWrapper(post,url.UPDATE_PASSWORD,data,formDataConfiguration);
export const updatePassword = (data, config = {}) =>apiWrapper(put, url.UPDATE_PASSWORD, data, config);


// banner
export const createBanner = (data) => apiWrapper(postForm,url.CREATE_BANNER,data);
export const getBanners = (data) => apiWrapper(get,url.GET_BANNERS,data);
export const getSingleBanner = (id) => apiWrapper(get,url.GET_SINGLE_BANNER + "/" + id);
export const updateBanners = (data, id) => apiWrapper(putForm,url.GET_BANNERS + "/" + id,data);

// Products
export const getAllProducts = (data) => apiWrapper(get,url.GET_ALL_PRODUCTS,data);

// Users
export const getAllUsers = (data) => apiWrapper(get,url.GET_ALL_USERS,data);
export const updateUser = (id, data) => apiWrapper(put, `${url.UPDATE_USER}/${id}`, data);
export const addUser = (data) => apiWrapper(post, url.ADD_USER, data);


// Dashboard
export const getDashboardData = (data) => apiWrapper(get,url.GET_DASHBOARD_DATA,data);

//FAQ

export const getFaqs = (data) => apiWrapper(get, url.GET_FAQS, data);
export const addFaq = (data) => apiWrapper(post, url.GET_FAQS, data);
export const updateFaq = (data, id) => apiWrapper(put, `${url.GET_FAQS}/${id}`, data);
export const deleteFaq = (data, id) => apiWrapper(del, `${url.GET_FAQS}/${id}`, data);
export const searchFaqs = (params) => apiWrapper(get, `${url.GET_FAQS}`, params);


// THREAD
export const getFilteredThreads = (params) => apiWrapper(get,url.GET_THREADS, params);
export const getThreadMessages = (id) => apiWrapper(get, `${url.GET_THREADS}/${id}`);
export const translateThread = (id, to) => apiWrapper(get, `${url.GET_THREADS}/${id}/translate`, { to });
export const getChatUsers = (params) => apiWrapper(get,url.GET_USERS, params);

// COMPANIES / CLIENTS
export const getCompanies = () => apiWrapper(get, url.GET_COMPANIES);
export const addCompany = (data) => apiWrapper(post, url.GET_COMPANIES, data);